const devConfig = {
  clientId: 'iOc2hgSn3Res8VLcJVB3u9XRdy6H8Rfo',
  domain: 'hiacode-dev.us.auth0.com',
  callbackUrl: window.location.origin,
  apiUrl: '{API_IDENTIFIER}',
  audience: 'https://hiacode-dev.us.auth0.com/api/v2/'
}

const prodConfig = {
  clientId: 'YOrYAyASMIsbT3C16FItGgvlBlA4kk9E',
  domain: 'hiacode.auth0.com',
  callbackUrl: window.location.origin,
  apiUrl: '{API_IDENTIFIER}',
  audience: 'https://hiacode.auth0.com/api/v2/'
}

function isDevEnvironment() {
  if (process.env.NODE_ENV === 'development') {
    return true
  }

  const { hostname, origin } = window.location

  return hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    origin.includes('nucleus-dev.hiacode.com')
}

export const AUTH_CONFIG = isDevEnvironment() ? devConfig : prodConfig
